/** HubSpot card iframes hosted under /external-apps/hubspot/ (JWT in URL path). */
export const isHubspotExternalAppPath = (pathname: string): boolean =>
  pathname.startsWith('/external-apps/hubspot/')

/** Lightweight picker iframe — referrals + patch are in query params, no list API. */
export const isHubspotDealPropertyChangePickerPath = (
  pathname: string
): boolean =>
  /^\/external-apps\/hubspot\/v1\/[^/]+\/partners\/[^/]+\/deal-property-change\/[^/]+/.test(
    pathname
  )
